var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgServicemanCallA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "144px",
    height: "144px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#f9e6c9;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.8,121.2l-16.9-18.8c-0.5-0.5-1.2-0.9-1.9-0.9s-1.4,0.3-1.9,0.8l-3.5,3.4c-2.4-2.4-6.9-7.7-12.1-16.6 c-5.2-9-7.4-15.5-8.3-18.8l4.7-1.3c0.7-0.2,1.3-0.7,1.6-1.3c0.3-0.6,0.4-1.4,0.2-2.1l-7.8-24.1c-0.2-0.8-0.8-1.4-1.6-1.7 c-0.7-0.3-1.6-0.2-2.3,0.2l-14.6,8.4c-0.5,0.3-0.9,0.8-1.2,1.4c-3.1,8.2,2.7,27.4,14.4,47.8c11.8,20.3,25.5,35,34.2,36.4 c0.1,0,0.3,0,0.4,0c0.5,0,0.9-0.1,1.3-0.4l14.6-8.4c0.7-0.4,1.2-1.1,1.3-1.9C79.6,122.6,79.4,121.7,78.8,121.2z M61.8,128.5 c-6.2-1.9-18.2-13.9-29.6-33.6C20.9,75.2,16.5,58.8,18,52.5l10.9-6.3l5.9,18.3l-3.4,0.9l0.1-0.1c-1.2,0.4-2.1,0.6-3.3,1 c0.1,1.1,0.1,2,0.3,3.3c0,0,0-0.1,0.1-0.1c0.5,2.4,2.6,10.3,9.4,22.1c6.7,11.6,12.4,17.3,14.3,19.1c0,0,0,0-0.1,0 c1,0.9,1.8,1.3,2.7,1.9c0.5-0.5,0.9-0.8,1.3-1.2c0.1-0.1,0.2-0.2,0.3-0.2l3.3-3.3l12.9,14.3L61.8,128.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.4,26c-3.2,0-6.6,1-6.8,1c-1.6,0.5-2.7,1.5-3,3c-0.4,1.4,0.1,2.9,1.2,4l11.6,11.6 c0.3,0.3,0.7,1.3,0.7,1.7v7.4h-7.4c-0.4,0-1.4-0.4-1.7-0.7L87.4,42.5c-0.9-0.9-2-1.4-3.1-1.4c-1.8,0-3.3,1.2-3.9,3.1 c0,0.1-1,3.5-1,6.8c0,8.3,4.2,16.1,11.1,20.8v45.7c0,4,3.3,7.3,7.3,7.3h8.9c4,0,7.3-3.3,7.3-7.3V74.2c9.4-3.8,15.5-12.9,15.5-23.2 C129.4,37.2,118.2,26,104.4,26z M110.2,69.4l-2,0.6v47.4c0,0.8-0.7,1.5-1.5,1.5h-8.9c-0.8,0-1.5-0.7-1.5-1.5v-49l-1.4-0.8 c-5.9-3.4-9.6-9.8-9.6-16.7c0-0.8,0.1-1.7,0.2-2.4l9.6,9.6c1.4,1.4,3.8,2.4,5.8,2.4h8.1c2.8,0,5.1-2.3,5.1-5.1v-8.1 c0-2-1-4.4-2.4-5.8l-9.6-9.6c0.8-0.1,1.6-0.2,2.4-0.2c10.6,0,19.3,8.6,19.3,19.3C123.6,59.5,118.2,66.9,110.2,69.4z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_2_1_"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgServicemanCallA);
export default __webpack_public_path__ + "static/media/img_ServicemanCall_a.48a7575cb9ace188c1c960b68f37b503.svg";
export { ForwardRef as ReactComponent };